
<ng-sidebar-container [ngClass]="{ 'nrk-nrka-background': issuer === 2, 'nrk-nrkg-background': issuer === 3 }">
  <ng-sidebar *ngIf="sideBarShow" [(opened)]="sideBarOpen" position="right" [animate]="sideBarAnimate" [keyClose]="false">
    <div #scrollContainer [ngClass]="{'nrk-nrka-background': issuer === 2, 'nrk-nrkg-background': issuer === 3, 'sidebar-fix': true, 'scroll-container': true}">

      <!-- debug -->
      <!-- pfspoWithShipment {{ selected.pfspoWithShipment }} <br> -->
      <div *ngIf="!tree.isLoading" class="banner" [class.visible]="showBanner">
        <span style="margin-right: 1rem">
          <span>{{this.selected | documentNumber}} - </span>
          <span>{{data.getBusinessName(this.selected.recipient) || '[]'}} - </span>
          <span>{{selected.customerDocumentNumber || 'none'}} - </span>
          <span>{{data.totalNet | ngxRound : 2 : true}} {{selected.currency}}</span>
        </span>
        <span *ngIf="typeData.get(selected.type).code !== 'OR' && (selected.internal || tree?.linkedFC?.code || tree?.linkedOR?.code)">
          <span *ngIf="selected.internal || tree?.linkedFC?.code || tree?.linkedOR?.code">{{selected.internal || tree?.linkedFC?.code || tree?.linkedOR?.code}}</span>
          <span *ngIf="tree?.linkedOR?.code"> - {{orderData?.totalNet | ngxRound : 2 : true}} {{tree?.linkedOR?.currency}}</span>
        </span>
      </div>
  
      <!-- *********************************************************** document form ***************************************************************************  -->

      <div *ngIf="!showDocumentPreview || showDocumentPreviewHidden" class="container">
        <!-- <form> -->

          <!-- ==================================================== header box (gray box) ===================================================================== -->
          <div class="header">
            <div class="doc-header">
              <div class="doc-nav">
                <div><button class="btn btn-default btn-sm" (click)="previousDocumentOfThisDoctype()"><nb-icon icon="arrow-circle-left-outline"></nb-icon></button></div>
                <div><button class="btn btn-default btn-sm" (click)="nextDocumentOfThisDoctype()"><nb-icon icon="arrow-circle-right-outline"></nb-icon></button></div>
              </div>

              <!-- header buttons (document tree / document mover / credit note heading selection / copy to clipboard) -->
              <ul class="doctree">
                <li *ngIf="selected.type != typeData.get('TOF').id">
                  <ngx-document-tree [compilation]="selected" (show)="setCurrentDocumentByCode($event.code)"></ngx-document-tree>
                  <br>
                  <ngx-document-combined-shipment-selector *ngIf="!readOnly && !tree.isLoading && !tree.linkedCS && data.visibleMap.combinedShipmentButton"
                    title="Add to grouped shipment" icon="ion-plus" [abstractItem]="this.selected" [latestVersionItems]="data.latestVersionItems"
                    (compilationChange)="addToCombinedShipment($event)"
                    buttonText="create new CS" (buttonClick)="createNewCsFromCurrentDocument()"
                  ></ngx-document-combined-shipment-selector>
                </li>
                <li *ngIf="!this.locked && selected.type != typeData.get('TOF').id">
                  <ngx-document-mover *ngIf="!readOnly" title="Attach document to" icon="ion-arrow-swap" [abstractItem]="this.selected" [latestVersionItems]="data.latestVersionItems"
                    buttonText="Detach from parent" (buttonClick)="removeParent(this.selected)"></ngx-document-mover>
                </li>
                <li *ngIf="issuer === 2" (click)="onChangeNrkjOverride()">
                  <button  
                    class="btn btn-default btn-sm" 
                    style="margin: 3px !important" 
                    [attr.disabled]="locked || null"
                    [style.opacity]="locked ? 0.5 : 1"
                    [style.background-color]="selected.nrkjOverride ? '#faf !important' : '#D3F8F4 !important'">
                    <b *ngIf="!selected.nrkjOverride" title="Mark as NRKJ Document">NRKA</b>
                    <b *ngIf="selected.nrkjOverride" title="Mark as NRKA Document">NRKJ</b>
                  </button>
                </li>
                <li *ngIf="typeData.get(selected.type)?.headings && !locked">
                  <button [nbPopover]="headingSelect" class="btn btn-default btn-small" style="margin: 3px !important; padding:5px" title="heading selection"><b>{{typeData.get(selected.type)?.code}}</b></button>
                  <ng-template #headingSelect>
                    <div style="margin:2em">
                      <h6>Select Heading:</h6>
                      <ng-container *ngFor="let heading of typeData.get(selected.type).headings; index as idx">
                        <div class="pseudo-link" (click)="selected.headingType = idx+1"><h4><b>{{heading}}</b></h4></div>
                      </ng-container>
                    </div>
                  </ng-template>
                </li>
              </ul>

              <!-- -------------------------- TITLE ---------------------------- -->
              <div class="title">
                <span [ngStyle]="{ 'text-align': 'center', 'flex': 1, 'font-size': '19pt' }">
                  <div style="height:2rem">{{getTitleString(selected)[0]}}</div>
                  <div>{{getTitleString(selected)[1]}}</div>
                  <ng-container *ngIf="data.getObicString(selected, tree)">
                    <div class="mt-2" style="font-size:smaller">{{data.getObicString(selected, tree)}}</div>
                  </ng-container>
                  <ng-container *ngIf="selected.trackingCode">
                    <div class="mt-2" style="font-size:smaller">{{selected.trackingCode}}</div>
                  </ng-container>
                </span>
              </div>
<!-- 
              <div class="title">
                <span [ngStyle]="{ 'text-align': 'center', 'flex': 1, 'font-size': getTitleString(selected).length > 55 ? '17pt' : '19pt' }">
                  {{getTitleString(selected)}}
                  <ng-container *ngIf="data.getObicString(selected, tree)">
                    <div class="mt-2" style="font-size:smaller">{{data.getObicString(selected, tree)}}</div>
                  </ng-container>
                  <ng-container *ngIf="selected.trackingCode">
                    <div class="mt-2" style="font-size:smaller">{{selected.trackingCode}}</div>
                  </ng-container>
                </span>
              </div>
 -->
              <div style="position:absolute;top:22px;right:22px">
                <div>
                  <button class="nrk-button" style="pointer-events:initial;" (click)="copyToClipboard(getProductLink())" title="copy product link to clipboard">copy link</button>
                  <button [nbPopover]="clipboardBtn" class="nrk-button ml-1" style="pointer-events:initial;" title="copy selected text to clipboard" [disabled]="!selected.recipient || null">&#64;</button>
                  <ng-template #clipboardBtn>
                    <div class="p-4">
                      <h5>copy to clipboard</h5>
                      <div *ngFor="let item of getClipboardList()"><a [routerLink]="[]" (click)="onClipboardList(item)">{{item}}</a></div>
                    </div>
                  </ng-template>
                  <ng-container *ngIf="!previewDisabled">
                    <button *ngIf="selected.type === typeData.get('OR').id && !tree.isLoading" class="nrk-button ml-2" (click)="lineItems.onORMail(-1)">&#64;OR full</button>
                    <button *ngIf="selected.type === typeData.get('OC').id && !tree.isLoading" class="nrk-button ml-2" (click)="lineItems.onOCMail(-1)">&#64;OC full</button>
                    <button *ngIf="['PFSPO','SPO'].includes(typeData.get(selected.type).code) && !tree.isLoading" class="nrk-button ml-2" (click)="lineItems.onSPOMail(-1)">&#64;(PF)SPO full</button>
                    <button *ngIf="selected.type === typeData.get('DN').id && !tree.isLoading" class="nrk-button ml-2" (click)="lineItems.copyPackingToClipboard(-1, true)">&#64;DN full</button>
                    <button *ngIf="['IN'].includes(typeData.get(selected.type).code) && !tree.isLoading" class="nrk-button ml-2" (click)="lineItems.onINMail()">&#64;IN full</button>
                  </ng-container>
                </div>
              </div>


              <div class="associated-docs">

                <!-- associated upstream documents / related combined shipment -->
                <div style="width:460px" *ngIf="!isOffersPage()">
                  <div *ngIf="selected?.parent" class="upstream">
                    <p>Associated upstream document</p>
                    <div><a [routerLink]="[]"
                        (click)="setCurrentDocumentByCode(selected.parent)">{{$any(selected).parent | documentNumber : data.latestVersionItems}}</a>
                    </div>
                  </div>
                  <ngx-loading-spinner [loading]="tree.isLoading" *ngIf="['SPO', 'PFSPO'].includes(typeData.get(selected.type).code) && tree.isLoading"></ngx-loading-spinner>
                  <div *ngIf="tree.linkedCS && !tree.isLoading" class="upstream">
                    <p>Related grouped shipment</p>
                    <div>
                      <button *ngIf="!locked" class="nrk-doc-button" (click)="removeFromCombinedShipment()" title="remove (PF)SPO from combined shipment">-</button>
                      &nbsp;<a [routerLink]="[]"
                        (click)="setCurrentDocumentByCode(tree.linkedCS.code)">{{tree.linkedCS | documentNumber}}</a>
                    </div>
                  </div>
                </div>

                <!-- associated downstream documents -->
                <div style="width:460px">

                  <!-- <div *ngIf="typeData.get(selected.type).code === 'OF'" class="mt-2 mb-3">
                    <button class="nrk-button" style="pointer-events:initial;" (click)="doCreateDocument(17, 'all', false, false, false)">
                      Create offer Template
                    </button>
                  </div> -->
  
                  <div *ngIf="typeData.get(selected.type)?.code === 'TOF'" class="mt-2 mb-3">
                    <button class="nrk-button" style="pointer-events:initial;" (click)="createOfferFromTemplate()">
                      Create offer from Template
                    </button>
                  </div>

                  <ng-container *ngIf="!isOffersPage()">
                    <div *ngIf="downstreamDocuments && downstreamDocuments.length > 0" class="downstream">
                      <p>Associated downstream documents</p>
                      <ng-container *ngFor="let doc of downstreamDocuments">
                        <div *ngIf="doc._id"><a [routerLink]="[]" [style.color]="doc.documentStatus === 3 ? '#0005' : null"
                            (click)="setCurrentDocumentByCode(doc.code)">
                              {{doc | documentNumber}}
                              <span *ngIf="doc.documentStatus === 3"> (cancelled)</span>
                            </a>
                            <a *ngIf="doc.type === typeData.get('IN').id && tree.findDocsByDownstreamType(doc.code, 'CN')?.[0]" [routerLink]="[]" [style.color]="doc.documentStatus === 3 ? '#0005' : null"
                              (click)="setCurrentDocumentByCode(tree.findDocsByDownstreamType(doc.code, 'CN')?.[0].code)">
                              &nbsp;({{tree.findDocsByDownstreamType(doc.code, 'CN')?.[0] | documentNumber}})
                            </a>
                        </div>
                      </ng-container>
                    </div>

                    <div
                      *ngIf="!readOnly && downstreamDocuments && downstreamDocuments.length > 0 && !selected.draft && getNewDownstreamDoctype() != null && selected._id && getDocumentStatus() !== 'cancelled' && locked"
                      class="associated-line">
                    </div>

                    <!-- create new document buttons (all / remaining / empty) -->
                    <div *ngIf="!readOnly && locked && getNewDownstreamDoctype() != null && !selected.draft && getDocumentStatus() !== 'cancelled'" class="generate-doc">
                      <div class="downstream-buttons" *ngFor="let type of getNewDownstreamDoctype()">
                        <div [ngClass]="{'nrk-nrka-background': type.code === 'OR-NRKA', 'nrk-nrkg-background': type.code === 'OC-NRKG'}">

                          <!-- general -->
                          <ng-container *ngIf="(type.code !== 'OR-NRKA' || !nrkaOrder.length) && (type.code !== 'OC-NRKG' || !nrkgOc.length)">
                            create new <span>{{type.name}}</span>&nbsp;
                            <button class="nrk-button" (click)="onCreateNewDocument(type.id, 'all')">all</button>
                            <ngx-line-item-remaining [typeName]="type.name" [compilation]="this.selected"
                              (newDownstreamDocFromLineItems)="doCreateRemainigDocuments(this.selected, type.id, $event)"></ngx-line-item-remaining>
                            <button class="nrk-button" (click)="onCreateNewDocument(type.id, 'empty')">empty</button>
                          </ng-container>

                          <!-- nrka order from nrkg -->
                          <ng-container *ngIf="type.code === 'OR-NRKA' && nrkaOrder.length">
                            <div *ngFor="let order of nrkaOrder">
                              Associated NRKA Order: <a style="display:inline-block;padding:3px;" [routerLink]="[]"
                                (click)="setCurrentDocumentByRoute(order)">{{$any(order) | documentNumber}}</a>
                            </div>
                          </ng-container>

                          <!-- nrkg order confirmation from nrka -->
                          <ng-container *ngIf="type.code === 'OC-NRKG' && nrkgOc.length">
                            <div *ngFor="let oc of nrkaOrder">
                              Associated NRKG Order confirmation: <a style="display:inline-block;padding:3px;" [routerLink]="[]"
                              (click)="setCurrentDocumentByRoute(oc)">{{$any(oc) | documentNumber}}</a>
                            </div>
                          </ng-container>

                        </div>
                      </div>

                      <!-- nrka pfspo from nrkg order / order confirmation -->
                      <ng-container *ngIf="issuer === issuerData.get('NRKG').id && ['OR', 'OC'].includes(typeData.get(selected.type).code)">
                        <div class="nrk-nrka-background pt-1">create new <button class="nrk-button" (click)="onCreateNrkaDocFromNrkg('PFSPO')">NRKA PFSPO</button></div>
                        <div class="nrk-nrka-background p-1">create new <button class="nrk-button" (click)="onCreateNrkaDocFromNrkg('SPO')">NRKV SPO</button></div>
                      </ng-container>

                      <!-- nrka pfin from nrkg invoice -->
                      <div *ngIf="issuer === issuerData.get('NRKG').id && ['IN', 'DN'].includes(typeData.get(selected.type).code)" class="nrk-nrka-background p-1">
                        <ng-container *ngIf="!tree?.docNode?.doc?.nrkgIn?.length && !tree.isLoading">create new <button class="nrk-button" (click)="onCreateNrkaDocFromNrkg('PFIN')">NRKA PFIN</button></ng-container>
                        <ng-container *ngIf="tree?.docNode?.doc?.nrkgIn?.length">
                          <div *ngFor="let nrkgIn of tree.docNode.doc.nrkgIn">
                            Associated NRKA PFIN: <a style="display:inline-block;padding:3px;cursor:pointer" [routerLink]=""
                            (click)="setCurrentDocumentByRoute(nrkgIn)">{{$any(nrkgIn) | documentNumber}}</a>
                          </div>
                        </ng-container>
                      </div>
                      <div *ngIf="issuer === issuerData.get('NRKA').id && ['PFIN'].includes(typeData.get(selected.type).code) && tree?.docNode?.doc?.nrkgIn?.length" class="nrk-nrkg-background p-1 mt-1">
                        <div *ngFor="let nrkgIn of tree.docNode.doc.nrkgIn">
                          Associated NRKG IN: <a style="display:inline-block;padding:3px;cursor:pointer" [routerLink]=""
                          (click)="setCurrentDocumentByRoute(nrkgIn)">{{$any(nrkgIn) | documentNumber}}</a>
                        </div>
                      </div>

                      <!-- nrka spc from nrkg PL / DN -->
                      <div *ngIf="issuer === issuerData.get('NRKG').id && ['PL', 'DN'].includes(typeData.get(selected.type).code)" class="nrk-nrka-background p-1">
                        create new <button class="nrk-button" (click)="onCreateNrkaDocFromNrkg('SPC')">NRKA SPC</button>
                      </div>

                      <div *ngIf="selected.pfspcCode?.length" class="nrk-nrkg-background">
                        Associated NRKG PFSPC: <a style="display:inline-block;padding:3px;" [routerLink]="[]"
                        (click)="setCurrentDocumentByRoute(selected.pfspcCode)">{{$any(selected).pfspcCode | documentNumber : data.latestVersionItems}}</a>
                      </div>

                      <!-- OBIC from (PF)SPO -->
                      <div *ngIf="['PFSPO', 'SPO'].includes(typeData.get(selected.type).code)">
                        create new <button class="nrk-button" (click)="onCreateParentObic()">parent OBIC</button> from (PF)SPO
                      </div>
                    </div>
                  </ng-container>

                  <!-- cancel OCs -->
                  <div *ngIf="['OR'].includes(typeData.get(selected.type)?.code) && this.downstreamDocuments?.length" style="padding:5px 0;background-color:#e008">
                    <button class="nrk-button" (click)="cancelOrderConfirmations()">cancel Order confirmations</button>
                  </div>

                </div>
              </div>
            </div>

            <!-- version buttons / document status (draft/final/cancelled/revised) -->
            <div class="docstatus">
              <label>Version</label>
              <div class="versions">
                <div *ngFor="let item of getVersions(selected)">
                  <button [ngClass]="{'nrk-doc-button': true, 'version-active': item.version == selected.version}" (click)="switchToVersion(item)">{{item.version}}</button>
                </div>
              </div>
              <div class="w-100">&nbsp;</div>
              <label>Status:&nbsp;<b>{{getDocumentStatus()}}</b></label>
            </div>
          </div>

          <div *ngIf="getDocumentStatus() === 'cancelled'">
            Cancel reason: {{selected.cancelReason}}
            <hr>
          </div>
          <div *ngIf="getDocumentStatus() === 'revised'">
            Revision reason: {{selected.cancelReason}}
            <hr>
          </div>
          <!-- end header box -->

          <!-- =================================================== document specific inputs ====================================================================== -->

          <div class="row ml-2 top-switches">
            <span *ngIf="data.visibleMap.invoiceStatus">
              Invoice status:&nbsp;
              <ngx-doc-form-dropdown [disabled]="readOnly" [options]="invoiceStatusOptions" [(value)]="selected.invoiceStatus" (valueChange)="setField('invoiceStatus', $event)"></ngx-doc-form-dropdown>
            </span>
            <!-- <ngx-doc-form-checkbox [disabled]="readOnly || typeData.get('OR').id !== selected.type" class="fullwidth" label="Sample request" [value]="selected.sampleRequest"
              (valueChange)="changeInTree('sampleRequest', $event);" >
            </ngx-doc-form-checkbox> -->
            <span>
              <input class="margin-top:-2px" type="checkbox" [ngModel]="selected.sampleRequest" (click)="changeInTree($event);" [attr.disabled]="readOnly || null"/>
              <label class="ml-2 mb-1" [ngStyle]="readOnly && {'color': '#888'}">Sample request</label>
            </span>
            <ngx-doc-form-checkbox [disabled]="readOnly" class="fullwidth" label="Internal document" [(value)]="selected.isInternalDocument" (valueChange)="setField('isInternalDocument', $event)">
            </ngx-doc-form-checkbox>
            <ngx-doc-form-checkbox [disabled]="(readOnly && !auth.user.admin) || previewDisabled" *ngIf="data.visibleMap.completelyInvoiced" class="fullwidth" label="Completely invoiced / not in OC report" [(value)]="selected.completelyInvoiced" (valueChange)="tree.synchronizeSharedFields(selected)">
            </ngx-doc-form-checkbox>
            <ngx-doc-form-checkbox [disabled]="readOnly && !auth.user.admin" *ngIf="data.visibleMap.projectCompleted" class="fullwidth" label="Project not displayed in project overview" [(value)]="selected.projectCompleted" (valueChange)="tree.synchronizeSharedFields(selected)">
            </ngx-doc-form-checkbox>
            <ngx-doc-form-checkbox [disabled]="readOnly && !auth.user.admin" *ngIf="data.visibleMap.notInInvoiceReport" class="fullwidth" label="Do not show in Invoice report" [(value)]="selected.notInInvoiceReport" (valueChange)="tree.synchronizeField(selected, 'notInInvoiceReport')">
            </ngx-doc-form-checkbox>
            <ngx-doc-form-checkbox [disabled]="readOnly" *ngIf="data.visibleMap.differentInvoiceAddress" class="fullwidth" [label]="docConfig.get('differentInvoiceAddress').label"
              [(value)]="selected.differentInvoiceAddress" (valueChange)="setField('differentInvoiceAddress', $event)">
            </ngx-doc-form-checkbox>
            <ng-container *ngIf="data.visibleMap.notInOrderReport">
              <ngx-doc-form-checkbox [disabled]="readOnly" class="fullwidth" label="Do not show in Order report" [(value)]="selected.notInOrderReport" (valueChange)="setField('notInOrderReport', $event)">
              </ngx-doc-form-checkbox>
            </ng-container>
            <div *ngIf="selected.type !== typeData.get('TOF').id">
              <button [disabled]="readOnly" class="nrk-button" (click)="generateOrderReport()">Generate Order Report</button>
            </div>
            <div *ngIf="['OC'].includes(typeData.get(selected.type).code)">
              <button class="nrk-button" (click)="profitCalcOCSPO.show()" [attr.disabled]="previewDisabled">OC &rarr; SPO Profit Margin</button>
            </div>
            <div *ngIf="selected.type === 16"> <!-- 16 === combined shipment -->
              <a class="nrk-button pseudo-unlink" [routerLink]="['/pages/erp/reports']" [queryParams]="getPfspoReportParams()">Open (PF)SPO Report</a>
              <a class="nrk-button pseudo-unlink ml-2" [routerLink]="['/pages/erp/reports']" [queryParams]="getNonInvoicedOCParams()">Non Invoiced OCs</a>
            </div>
            <div *ngIf="['OR'].includes(typeData.get(selected.type)?.code)">
              <ngx-doc-form-checkbox style="display:inline-block" [disabled]="readOnly && !auth.user.admin" class="fullwidth" label="Order Acknowledgement" [(value)]="selected.orderAcknoledgement">
              </ngx-doc-form-checkbox>
            </div>
            <div *ngIf="['OF', 'OR'].includes(typeData.get(selected.type)?.code)">
              <button class="nrk-button ml-4" (click)="internalUpdates.open(selected)">Connected Projects</button>
            </div>
            <div *ngIf="['OC', 'DN', 'IN'].includes(typeData.get(selected.type)?.code)">
              <ngx-messaging #messageWindow [compilation]="selected"></ngx-messaging>
              <div style="background-color:beige;padding:0.3rem;border:1px solid #ddd;border-radius:5px">
                <button class="nrk-button" (click)="messageWindow.reloadMessages(); messageWindow.messagingMode = messagingWindowMode.overviewWindow; messageWindow.show()">Messaging ({{messages.length}})</button>
                <div *ngFor="let msg of messages">{{msg.subject}}</div>
              </div>
            </div>
            <div *ngIf="['OR', 'OC'].includes(typeData.get(selected.type).code)">
              <div style="background-color:beige;padding:0.3rem;border:1px solid #ddd;border-radius:5px">
                <button class="nrk-button" (click)="internalUpdates.open(selected)">Internal Updates</button>
                <div *ngIf="selected.sampleRequest" class="mt-1">SR Status: <b>{{srStatus}}</b></div>
                <div>{{selected.internalUpdates?.substring(0, 20)}}{{selected.internalUpdates?.length > 20 ? '…' : ''}}</div>
              </div>
            </div>
            <span *ngIf="data.visibleMap.invoicePayment">
              Invoice payment:&nbsp;
              <ngx-doc-form-dropdown [disabled]="readOnly" [options]="invoicePaymentOptions" [(value)]="selected.invoicePayment" [disabled]="locked"></ngx-doc-form-dropdown>
            </span>
            <span style="margin-right:1em" *ngIf="data.visibleMap.creditNoteReason">
              Credit note reason:&nbsp;
              <ngx-doc-form-texfield [styles]="{ width: '38em'}" [(value)]="selected.creditNoteReason" (valueChange)="setField('creditNoteReason', $event)"></ngx-doc-form-texfield>
              <!-- <br>Credited Invoice: {{tree.linkedIN.code}} -->
            </span>
            <div *ngIf="['CS'].includes(typeData.get(selected.type)?.code)">
              <!-- GS Status: -->
              <button class="nrk-button" (click)="profitCalc.show()">GS Status</button> :
              <span *ngIf="selected.csCompleted" style="padding:0.5rem;border-radius:5px;background-color:lightgreen">Closed</span>
              <span *ngIf="!selected.csCompleted" style="padding:0.5rem;border-radius:5px;background-color:lightgray">Open</span>
            </div>

            <!-- offer fields -->
            <ul *ngIf="data.visibleMap.offerFields && selected.offerData" class="offer-fields" style="padding-left:0">
              <ng-container *ngFor="let field of offerFields">
                <li [ngStyle]="{ width: field.value['type']==='percent' ? '6.5em' : null }">
                  <label>{{field.value['label']}}</label>
                  <div *ngIf="field.value['type']==='actionPoint'" class="fullwidth">
                    <ngx-doc-form-dropdown [disabled]="readOnly" [(value)]="selected.offerData[field.key]"
                      [options]="actionPointOptions" (valueChange)="onOfferDataChanged(field.key, $event)"></ngx-doc-form-dropdown>
                  </div>
                  <div *ngIf="field.value['type']==='offerStatus'" class="fullwidth">
                    <ngx-doc-form-dropdown [disabled]="readOnly" [(value)]="selected.offerData[field.key]"
                      [options]="offerStatusOptions" (valueChange)="onOfferDataChanged(field.key, $event)"></ngx-doc-form-dropdown>
                  </div>
                  <div *ngIf="field.value['type']==='statusComment'" class="fullwidth">
                    <ngx-doc-form-dropdown [disabled]="readOnly" [styles]="{width:'21em'}" [(value)]="selected.offerData[field.key]"
                      [options]="statusCommentOptions" (valueChange)="onOfferDataChanged(field.key, $event)"></ngx-doc-form-dropdown>
                  </div>
                  <div *ngIf="field.value['type']==='text'">
                    <ngx-doc-form-texfield [disabled]="readOnly" [styles]="{width:'25em'}" class="fullwidth" [(value)]="selected.offerData[field.key]" (valueChange)="onOfferDataChanged(field.key, $event)"></ngx-doc-form-texfield>
                  </div>
                  <div *ngIf="field.value['type']==='checkbox'">
                    <ngx-doc-form-checkbox [(value)]="selected.offerData[field.key]" (valueChange)="onOfferDataChanged(field.key, $event)"></ngx-doc-form-checkbox>
                  </div>
                  <ngx-doc-form-dropdown [disabled]="readOnly" *ngIf="field.value['type']==='percent'" [styles]="{width:'5em'}" class="fullwidth" [(value)]="selected.offerData[field.key]"
                    [options]="percentOptions" (valueChange)="onOfferDataChanged(field.key, $event)"></ngx-doc-form-dropdown>
                </li>
              </ng-container>
              <li>
                <label>Last update</label>
                <div>
                  <!-- {{selected.offerData.updatedAt | date : 'yyyy-MM-dd HH:mm:ss' }} -->
                  <ngx-doc-form-texfield [styles]="{width:'7em','margin-right':'5px','text-align':'center'}"
                    [value]="selected.offerData.updatedAt | date : 'yyyy-MM-dd'" [disabled]="true"></ngx-doc-form-texfield>
                  <button [disabled]="readOnly" class="nrk-button" (click)="onOfferDataChanged('updatedAt', null)">🗘</button>
                </div>
              </li>
            </ul>
          </div>
          <hr>

          <ng-container *ngIf="['DN', 'IN', 'PFIN'].includes(typeData.get(selected.type).code) && !tree.isLoading">
            <div class="row ml-2 top-switches">
              <div>Delivery Note Status: </div>
              <!-- <div class="ml-2 text-center" [ngStyle]="{'width': '12rem', 'padding': '0.5rem', 'border-radius' : '4px', 'background-color': ['#ddd','#fb3c','#0afa','#0c0a','#0f0a'][selected.packingStatus || 0]}">
                {{['Not Ready for Packing','Ready for Packing','Ready for Dispatch','Dispatched','Completed'][selected.packingStatus || 0]}}
              </div> -->
              <div style="width:15rem"><ngx-dn-status [compilation]="this.selected"></ngx-dn-status></div>
              <div>
                <ng-container *ngIf="!readOnly"> 
                  Set <ng-container *ngFor="let status of [0,1,2,3,4,5]">
                    <button class="nrk-button dn-status" (click)="setPackingStatus(status)" [attr.disabled]="packingStatusDisabled(status)">{{dnStatusText(status)}}</button>
                  </ng-container>
                  <!-- <div *ngIf="!selected.packingStatus" style="width:13rem"><button class="nrk-button" (click)="setPackingStatus(1)">Set Ready for Packing</button></div>
                  <div *ngIf="selected.packingStatus === 1" style="width:13rem"><button class="nrk-button" (click)="setPackingStatus(2)">Set Completed</button></div>
                  <div *ngIf="selected.packingStatus === 1" style="width:13rem"><button class="nrk-button" (click)="setPackingStatus(3)">Set Completed</button></div>
                  <div *ngIf="selected.packingStatus > 1" style="width:13rem"><button class="nrk-button" (click)="setPackingStatus(4)" [attr.disabled]="selected.packingStatus > 3 || null">Set Completed</button></div>
                  <div style="width:8rem"><button class="nrk-button" (click)="setPackingStatus([undefined,undefined,1,2,3][selected.packingStatus])" [attr.disabled]="!selected.packingStatus || null">Undo</button></div> -->
                </ng-container>
              </div>
            </div>
            <hr>
          </ng-container>

          <!-- ======= send to addresses ======= -->

          <ng-container *ngIf="selected.invoiceSendTo?.length || ocSendTo?.length || invoiceSendTo?.length || deliveryNoteSendTo?.length || testCertificateSendTo?.length || invoiceReminderSendTo?.length || data.visibleMap.fiscalYear">
            <div class="row send-to-address">
              <div *ngIf="ocSendTo?.length" class="row p-2">
                <div>Send OC to:</div>
                <div>{{(ocSendTo).split('\n')[0]}}</div>
                <div class="ml-2"><span [nbPopover]="ocSendToTpl" style="cursor:pointer">ℹ️</span></div>
                <ng-template #ocSendToTpl>
                  <div class="send-to-info">
                    {{ocSendTo}}<br><br><b>Info:</b>
                    <ngx-form-text [multiline]="1" [(value)]="ocSendToInfo.info"></ngx-form-text>
                    <button class="nrk-button" (click)="saveBusinessSendToInfo(ocSendToInfo); hidePopovers()">save</button>
                  </div>
                </ng-template>
              </div>
              <div *ngIf="selected.invoiceSendTo?.length || invoiceSendTo?.length" class="row p-2">
                <div>Send IN to:</div>
                <div>{{(selected.invoiceSendTo || invoiceSendTo).split('\n')[0]}}</div>
                <div class="ml-2"><span [nbPopover]="invoiceSendToTpl" style="cursor:pointer">ℹ️</span></div>
                <ng-template #invoiceSendToTpl>
                  <div class="send-to-info">
                    {{selected.invoiceSendTo || invoiceSendTo}}<br><br><b>Info:</b>
                    <ngx-form-text [multiline]="1" [(value)]="invoiceSendToInfo.info"></ngx-form-text>
                    <button class="nrk-button" (click)="saveBusinessSendToInfo(invoiceSendToInfo); hidePopovers()">save</button>
                  </div>
                </ng-template>
              </div>
              <div *ngIf="deliveryNoteSendTo?.length" class="row p-2">
                <div>Send DN to:</div>
                <div>{{deliveryNoteSendTo.split('\n')[0]}}</div>
                <div class="ml-2"><span [nbPopover]="deliveryNoteSendToTpl" style="cursor:pointer">ℹ️</span></div>
                <ng-template #deliveryNoteSendToTpl>
                  <div class="send-to-info">
                    {{deliveryNoteSendTo}}<br><br><b>Info:</b>
                    <ngx-form-text [multiline]="1" [(value)]="deliveryNoteSendToInfo.info"></ngx-form-text>
                    <button class="nrk-button" (click)="saveBusinessSendToInfo(deliveryNoteSendToInfo); hidePopovers()">save</button>
                  </div>
                </ng-template>
              </div>
              <div *ngIf="testCertificateSendTo?.length" class="row p-2">
                <div>Send TC to:</div>
                <div>{{testCertificateSendTo.split('\n')[0]}}</div>
                <div class="ml-2"><span  [nbPopover]="testCertificateSendToTpl"style="cursor:pointer">ℹ️</span></div>
                <ng-template #testCertificateSendToTpl>
                  <div class="send-to-info">
                    {{testCertificateSendTo}}<br><br><b>Info:</b>
                    <ngx-form-text [multiline]="1" [(value)]="testCertificateSendToInfo.info"></ngx-form-text>
                    <button class="nrk-button" (click)="saveBusinessSendToInfo(testCertificateSendToInfo); hidePopovers()">save</button>
                  </div>
                </ng-template>
              </div>
              <div *ngIf="invoiceReminderSendTo?.length" class="row p-2">
                <div>Send Invoice Reminder to:</div>
                <div>{{invoiceReminderSendTo?.split('\n')[0]}}</div>
                <div class="ml-2"><span  [nbPopover]="testCertificateSendToTpl"style="cursor:pointer">ℹ️</span></div>
                <ng-template #testCertificateSendToTpl>
                  <div class="send-to-info">
                    {{invoiceReminderSendTo}}<br><br><b>Info:</b>
                    <ngx-form-text [multiline]="1" [(value)]="invoiceReminderSendToInfo.info"></ngx-form-text>
                    <button class="nrk-button" (click)="saveBusinessSendToInfo(invoiceReminderSendToInfo); hidePopovers()">save</button>
                  </div>
                </ng-template>
              </div>
              <div *ngIf="data.visibleMap.fiscalYear" class="row" [ngStyle]="{'align-items':'baseline','border': fiscalNotDispatchDate(selected) ? '2px solid violet' : 'none'}">
                <div>Fiscal Year:</div>
                <div class="ml-1 text-center">
                  <input style="width:1em" type="checkbox" [ngModel]="selected.visibleFields.includes('fiscalYear')" (ngModelChange)="toggleField('fiscalYear')" title="show in PDF"/>
                </div>
                <div>
                  <ngx-doc-form-dropdown [(value)]="selected.fiscalYear" [options]="fiscalYearOptions" [disabled]="locked"></ngx-doc-form-dropdown>
                  {{ fiscalNotDispatchDate(selected) ? '≠ dispatch' : '' }}
                </div>
              </div>
            </div>
            <hr>
          </ng-container>
                   
          
          <!-- invoice upload (test certificate / transaction receipt / prove of delivery) -->
          <div *ngIf="selected && data.visibleMap.showInvoiceUpload">
            <ng-container *ngFor="let section of ['transactionReceipt', 'proveOfDelivery', 'testCertificate']">
              <div *ngIf="data.visibleMap[section] && selected[section]">
                <h5>{{getLabel(section)}}</h5>
                <!-- <ngx-doc-form-checkbox [disabled]="readOnly || !selected[section].files?.length" label="completed" [(value)]="selected[section].completed" 
                  (valueChange)="updateInvoiceUpload(section, false)"></ngx-doc-form-checkbox> -->
                <ngx-doc-form-checkbox [disabled]="readOnly" [label]="selected[section].files?.length ? 'completed' : 'not applicable'" [(value)]="selected[section].completed" 
                  (valueChange)="updateInvoiceUpload(section, false)"></ngx-doc-form-checkbox>
                <div class="file-upload" style="padding-top:5px;border: none;" *ngIf="selected[section]">
                  <ngx-form-upload [disabled]="readOnly" class="file-upload-comp" url="/api/v1/upload" accept="application/pdf"
                    [(files)]="selected[section].files" [fullwidth]="true" [hideComment]="false" [hideCheckbox]="true"
                    (filesChange)="updateInvoiceUpload(section, true)">
                  </ngx-form-upload>
                </div>
                <div *ngIf="section === 'transactionReceipt'">
                  Payment Date:
                  <ngx-doc-form-date [(value)]="$any(selected).paymentDate" (valueChange)="updatePaymentDate()"></ngx-doc-form-date>
                </div>
                <hr>
              </div>
            </ng-container>
          </div>

          <div *ngIf="['DN'].includes(typeData.get(selected.type).code)">
            <h5>Proof of Delivery</h5>
            <ngx-form-upload [disabled]="readOnly" class="file-upload-comp" url="/api/v1/upload" accept="application/pdf"
              [(files)]="selected.proveOfDelivery.files" [fullwidth]="true" [hideComment]="false" [hideCheckbox]="true"
              (filesChange)="updateInvoiceUpload('proveOfDelivery', true, false)">
            </ngx-form-upload>
          </div>


          <div class="mt-4" *ngIf="selected.recipient">
            <button class="nrk-button" (click)="infoWin.show()">Open {{data.getBusinessName(selected.recipient)}} General Information</button>
            <div *ngIf="businessGeneralInfo" style="display:inline-block;margin-left:2rem;white-space:pre-wrap">{{businessGeneralInfo.length > 200 ? businessGeneralInfo.slice(2,200) + '…' : businessGeneralInfo}}</div>
            <nrk-window #infoWin>
              <nrk-header>General Information</nrk-header>
              <nrk-content [ngStyle]="{'min-width': '40rem', 'display': 'block'}">
                <h5>{{data.getBusinessName(selected.recipient)}}</h5>
                <div style="display:flex;padding:0.5rem;">
                  <div *ngIf="selected.invoiceSendTo?.length || invoiceSendTo?.length">
                    <div><b>Send IN to:</b></div>
                    <div class="send-to-info">{{selected.invoiceSendTo || invoiceSendTo}}</div>
                  </div>
                  <div *ngIf="deliveryNoteSendTo?.length">
                    <div><b>Send DN to:</b></div>
                    <div class="send-to-info">{{deliveryNoteSendTo}}</div>
                  </div>
                  <div *ngIf="testCertificateSendTo?.length">
                    <div><b>Send TC to:</b></div>
                    <div class="send-to-info">{{testCertificateSendTo}}</div>
                  </div>
                  <div *ngIf="invoiceReminderSendTo?.length">
                    <div><b>Send Invoice Reminder to:</b></div>
                    <div class="send-to-info">{{invoiceReminderSendTo}}</div>
                  </div>                
                </div>
                <b>General Information</b>
                <ngx-form-text [multiline]="10" [(value)]="businessGeneralInfo"></ngx-form-text>
              </nrk-content>
              <nrk-footer>
                <button class="btn btn-sm btn-success" (click)="saveBusinessGeneralInfo();infoWin.hide()">Save</button>
                <button class="btn btn-sm btn-danger" (click)="businessGeneralInfo=data.getBusiness(selected.recipient)?.generalInfo;infoWin.hide()">
                  Cancel
                </button>
              </nrk-footer>
            </nrk-window>
          </div>

          <div class="top-segment">

            <!-- ============================================ document status / recipient ... ============================================================================= -->
            <div class="left-contact">
              <ul class="flex-outer">
                <!-- <ngx-doc-form-address-selector #recipientSelector label="Recipient" labelAlign="left" [businesses]="recipientBusinesses" [(business)]="selected.recipient"
                  [compilation]="selected" [contacts]="contacts" [contactField]="'recipientContact'" [border]="false"
                  [(address)]="selected.recipientAddress" [contactType]="contactTypes.General" (businessChange)="setBusinesses(true)" [disabled]="locked"
                  [invoiceSendTo]="['IN', 'PFIN'].includes(typeData.get(selected.type).code)" [(address2)]="selected.invoiceSendTo"
                  (contactChange)="onRecipient($event)">
                </ngx-doc-form-address-selector> -->
                <ngx-doc-form-address-selector 
                  *ngIf="!['DN'].includes(typeData.get(this.selected.type).code) || this.selected.invoiceType !== 'delivery'"
                  #recipientSelector label="Recipient" labelAlign="left" [businesses]="recipientBusinesses" [(business)]="selected.recipient"
                  [compilation]="selected" [contacts]="contacts" [contactField]="'recipientContact'" [border]="false"
                  [(address)]="selected.recipientAddress" [contactType]="contactTypes.General" (businessChange)="setBusinesses(true)" [disabled]="locked"
                  [invoiceSendTo]="true" [(address2)]="selected.invoiceSendTo"
                  (contactChange)="onRecipient($event)">
                </ngx-doc-form-address-selector>

                <ngx-doc-form-address-selector 
                  *ngIf="['DN'].includes(typeData.get(this.selected.type).code) && this.selected.invoiceType === 'delivery'"
                  label="Delivery address" labelAlign="left" [businesses]="deliveryBusinesses"
                  [compilation]="selected" [contacts]="contacts" [contactField]="'deliveryContact'" 
                  [(address)]="selected.deliveryAddress" [(business)]="selected.deliveryRecipient" [contactType]="contactTypes.Delivery" (contactChange)="onDeliveryChange($event)"
                  (businessChange)="setDNBusinessFields($event)" [disabled]="locked">
                </ngx-doc-form-address-selector>

                <li>
                  <label>Recipient UID&nbsp;/&nbsp;CRN</label>
                  <ngx-doc-form-textarea class="fullwidth" [rows]="2" placeholder="Recipient UID / company registration number"
                    [value]="selected.paymentPlan?.recipientUID" (valueChange)="selected.paymentPlan.recipientUID=$event" [disabled]="locked"></ngx-doc-form-textarea>
                </li>
                <li>
                  <label>
                    <i *ngIf="!['DN'].includes(typeData.get(this.selected.type).code)">Reception Hours</i>
                    <span *ngIf="['DN'].includes(typeData.get(this.selected.type).code)">Reception Hours</span>
                  </label>
                  <ngx-form-text 
                    class="fullwidth" 
                    [value]="tree?.linkedDN?.receptionHours || tree?.linkedOC?.receptionHours || selected.receptionHours"
                    [multiline]="1"
                    (valueChange)="selected.receptionHours = $any($event)"
                    [disabled]="locked || !['DN'].includes(typeData.get(this.selected.type).code)"
                  ></ngx-form-text>
                </li>
                <li>
                  <label>Company Holidays</label>
                  <div>
                    <div style="display:inline-block;width:8rem"><ngx-doc-form-date class="fullwidth" [(value)]="$any(selected).holidays[0]" [disabled]="locked"></ngx-doc-form-date></div>
                    <div style="display:inline-block;width:2rem;text-align:center"> - </div>
                    <div style="display:inline-block;width:8rem"><ngx-doc-form-date class="fullwidth" [(value)]="$any(selected).holidays[1]" [disabled]="locked"></ngx-doc-form-date></div>
                  </div>
                </li>
              </ul>
            </div>

            <!-- ======================================================= issuer, contact... ================================================================== -->
            <div class="right-contact">
              <ul class="flex-outer">
                <li>
                  <label>Issuer</label>
                  <!-- <ngx-doc-form-dropdown class="fullwidth" [(value)]="selected.issuer" [options]="issuerOptions"
                    (valueChange)="onIssuerChanged($event)" [disabled]="!isOffersPage() || locked"></ngx-doc-form-dropdown> -->
                  <ngx-doc-form-dropdown class="fullwidth" [(value)]="selected.issuer" [options]="issuerOptions"
                    (valueChange)="onIssuerChanged($event)" [disabled]="true"></ngx-doc-form-dropdown>
                </li>
                <li>
                  <label>Address</label>
                  <ngx-doc-form-textarea class="fullwidth" rows="6" placeholder="Issuer address"
                    [(value)]="selected.issuerAddress" [disabled]="locked"></ngx-doc-form-textarea>
                </li>
                <!-- <li *ngIf="['PFSPO']">
                  <label>PFSPO IN Disclaimer</label>
                  <ngx-doc-form-textarea class="fullwidth" rows="5" placeholder="PFSPO IN Disclaimer"
                    [(value)]="selected.pfspoInDisclaimer" [disabled]="locked"></ngx-doc-form-textarea>
                </li> -->
                <li>
                  <label>Contact</label>
                  <ngx-doc-form-dropdown class="fullwidth"
                    [options]="data.userOptions" (valueChange)="onIssuerContactChanged($event)" [disabled]="locked"></ngx-doc-form-dropdown>
                </li>
                <li>
                  <label>Contact Info</label>
                  <ngx-doc-form-textarea class="fullwidth" rows="6" placeholder="Issuer contact"
                    [(value)]="selected.issuerContact" [disabled]="locked"></ngx-doc-form-textarea>
                </li>
                <li *ngIf="selected.type === typeData.get('OF').id">
                  <label></label>
                  {{'purchase_order_nrka@nipponrika.eu'}}
                </li>
                <li *ngIf="selected.type === typeData.get('IN').id">
                  <label></label>
                  {{'invoices_nrka@nipponrika.eu'}}
                </li>
              </ul>
            </div>
          </div>

          <hr>

          <div class="info-segment">

            <!-- =================================================== customer / document / nrk reference ====================================================================== -->

 
            <div class="reference-row">
              <ul>
                <li>
                  <p>Customer Reference</p>
                </li>
                <li>
                  <label>Name</label>
                  <ngx-doc-form-filter-select class="fullwidth" [options]="customerReferenceOptions" [(value)]="$any(selected).customerReference" (valueChange)="customerNameChange($event)" [disabled]="locked" placeholder="Select customer"></ngx-doc-form-filter-select>
                </li>
                <li *ngIf="!selected.customerReference && selected.customerName">
                  <label>&nbsp;</label>
                  <ngx-doc-form-texfield class="fullwidth" [(value)]="selected.customerName" [disabled]="true"></ngx-doc-form-texfield>
                </li>
                <ng-container *ngIf="data.visibleMap.customerPO">
                  <li>
                    <label>PO Number</label>
                    <ngx-doc-form-texfield class="fullwidth" [(value)]="selected.customerDocumentNumber" [disabled]="locked"></ngx-doc-form-texfield>
                  </li>
                  <li>
                    <label>PO Date</label>
                    <ngx-doc-form-date class="fullwidth" [(value)]="$any(selected).customerDocumentDate" [disabled]="locked"></ngx-doc-form-date>
                  </li>
                </ng-container>
                <ng-container *ngIf="data.visibleMap.awbBlContNr">
                  <li>
                    <label>AWB / BL NO</label>
                    <ngx-doc-form-texfield class="fullwidth" [(value)]="selected.awbBlNr" [disabled]="locked"></ngx-doc-form-texfield>
                  </li>
                  <li>
                    <label>CONT NO</label>
                    <ngx-doc-form-texfield class="fullwidth" [(value)]="selected.contNr" [disabled]="locked"></ngx-doc-form-texfield>
                  </li>
                </ng-container>
                <ng-container *ngIf="data.visibleMap.requestForQuotation">
                  <li>
                    <label>RFQ Reference</label>
                    <ngx-doc-form-texfield class="fullwidth" [(value)]="selected.rfqReference" [disabled]="locked">
                    </ngx-doc-form-texfield>
                  </li>
                  <li>
                    <label>RFQ Date</label>
                    <ngx-doc-form-date class="fullwidth" [(value)]="$any(selected).rfqDate" [disabled]="locked"></ngx-doc-form-date>
                  </li>
                </ng-container>
                <ng-container *ngIf="!['FCOR'].includes(typeData.get(selected.type).code) && tree?.linkedFC">
                  <li>
                    <label>Frame Contract</label>
                    <ngx-doc-form-texfield class="fullwidth" [value]="tree?.linkedFC?.customerDocumentNumber" [disabled]="true">
                    </ngx-doc-form-texfield>                  
                  </li>
                  <li>
                    <label>FC Date</label>
                    <ngx-doc-form-date class="fullwidth" [value]="tree?.linkedFC?.customerDocumentDate" [disabled]="true"></ngx-doc-form-date>                  
                  </li>
                </ng-container>
                <!-- <ng-template #nofc>
                  <li>
                    <label>Customer Document Number</label>
                    <ngx-doc-form-texfield class="fullwidth" [(value)]="selected.customerDocumentNumber" [disabled]="locked">
                    </ngx-doc-form-texfield>                  
                  </li>
                  <li>
                    <label>Customer Document Date</label>
                    <ngx-doc-form-date class="fullwidth" [(value)]="$any(selected).customerDocumentDate" [disabled]="locked"></ngx-doc-form-date>                  
                  </li>
                </ng-template> -->
              </ul>


              <!-- <li *ngIf="tree.linkedCS">
                <p>Shipment reference</p>
              </li>
              <li *ngIf="tree.linkedCS">
                <label>Related CS</label>
                <ngx-doc-form-texfield class="fullwidth" [(value)]="this.selected.transportRun.relatedCS" [disabled]="true"></ngx-doc-form-texfield>
              </li> -->

              <ul>
                <li>
                  <p>Nippon Rika Reference</p>
                </li>
                <li>
                  <label>Issue date</label>
                  <ngx-doc-form-date class="fullwidth" [(value)]="$any(selected).issueDate" [disabled]="locked"></ngx-doc-form-date>
                </li>
                <li>
                  <label>Name override</label>
                  <div><div *ngIf="selected.nameOverride?.length" style="color:gray">{{ selected.code }}↴</div>
                  <ngx-doc-form-texfield class="fullwidth" [(value)]="selected.nameOverride" [disabled]="locked">
                  </ngx-doc-form-texfield></div>
                </li>
                <li>
                  <label>Quotation Ref</label>
                  <ngx-doc-form-texfield class="fullwidth" [value]="tree?.linkedOF?.nameOverride || tree?.linkedOF?.code" [disabled]="true"></ngx-doc-form-texfield>
                </li>
                <li *ngIf="tree?.linkedCsSpoCodes?.length" class="mt-2">
                  <label>Docs</label>
                  <div class="textbox">{{tree.linkedCsSpoCodes.join('\n')}}</div>
                </li>
              </ul>

              
              <ul>
                <li>
                  <p>Manufacturer Reference</p>
                </li>
                <li>
                  <label>Project Number</label>
                  <ngx-doc-form-texfield class="fullwidth" [value]="selected.internal || tree?.linkedFC?.code || tree?.linkedOR?.code" (valueChange)="selected.internal = $event" [disabled]="locked"></ngx-doc-form-texfield>
                </li>
                <li>
                  <label>Machine S/N</label>
                  <!-- <ngx-doc-form-texfield class="fullwidth" [(value)]="selected.machineSN" [disabled]="locked"></ngx-doc-form-texfield> -->
                  <ngx-doc-form-textarea style="position:relative;top:1rem" [rows]="2" [(value)]="selected.machineSN" class="fullwidth" [disabled]="locked"></ngx-doc-form-textarea>
                </li>
              </ul>

            </div>


            <!-- =================================================== delivery / place of loading / service provided ====================================================================== -->

            <div class="delivery-service-radio">
              <ul>
                <li>Type:</li>
                <li><input [attr.disabled]="readOnly ? true : null" type="radio" value="delivery" name="invoiceType" [(ngModel)]="selected.invoiceType" (click)="onInvoiceType('delivery', false)" /><span (click)="onInvoiceType('delivery')">Delivery</span></li>
                <!-- <li><input [attr.disabled]="readOnly ? true : null" type="radio" value="pickup" name="invoiceType" [(ngModel)]="selected.invoiceType" (click)="onInvoiceType('pickup', false)"/><span (click)="onInvoiceType('pickup')">Pickup</span></li> -->
                <li><input [attr.disabled]="readOnly ? true : null" type="radio" value="service" name="invoiceType" [(ngModel)]="selected.invoiceType" (click)="onInvoiceType('service', false)"/><span (click)="onInvoiceType('service')">Service</span></li>
              </ul>
            </div>

            <div class="address-row">

              <!-- <ul *ngIf="this.selected.invoiceType ==='delivery' && !['DN'].includes(typeData.get(this.selected.type).code)"> -->
              <ul *ngIf="this.selected.invoiceType === 'delivery'">
                <li>
                  <ngx-doc-form-address-selector [businesses]="deliveryBusinesses"  label="Delivery Address"
                    [compilation]="selected" [contacts]="contacts" [contactField]="'deliveryContact'" 
                    [(address)]="selected.deliveryAddress" [(business)]="selected.deliveryRecipient" [contactType]="contactTypes.Delivery" (contactChange)="onDeliveryChange($event)"
                    (businessChange)="data.setCSIdentifier(selected)" [disabled]="locked">
                  </ngx-doc-form-address-selector>
                </li>
              </ul>
              <ul *ngIf="this.selected.invoiceType === 'service'">
                <li>
                  <ngx-doc-form-address-selector [businesses]="deliveryBusinesses" label="Service Provided" 
                    [(address)]="selected.serviceProvided" [(business)]="selected.serviceRecipient"
                    [contactType]="contactTypes.Delivery" [disabled]="locked">
                  </ngx-doc-form-address-selector>
                </li>                
              </ul>

              <ul>
                <li>
                  <ngx-doc-form-address-selector  *ngIf="data.visibleMap.placeOfLoading" [label]="selected.invoiceType === 'pickup' ? 'Place of Delivery' : 'Place of Loading'" [businesses]="placeOfLoadingBusinesses" 
                    [compilation]="selected" [contacts]="contacts" [contactField]="'placeOfLoadingContact'" 
                    [(address)]="selected.placeOfLoading"  [(business)]="selected.placeOfLoadingRecipient"
                    (businessChange)="!selected.placeOfLoadingRecipient && selected.placeOfLoading = null" [disabled]="locked">
                  </ngx-doc-form-address-selector>
                </li>
              </ul>

              <ul>
                <li>
                  <ngx-doc-form-address-selector [label]="selected.invoiceType === 'service' ? 'Serviceprovider Address' : 'Manufacturer Address'" [businesses]="manufacturerBusinesses" 
                    [compilation]="selected" [contacts]="contacts" [contactField]="'manufacturerContact'"
                    [(address)]="selected.manufacturerServiceproviderAddress" [(business)]="selected.manufacturerRecipient"
                    (businessChange)="data.setCSIdentifier(selected)" [disabled]="locked">
                  </ngx-doc-form-address-selector>
                </li>
              </ul>

              <!-- <ul *ngIf="this.selected.invoiceType !=='service' && ['DN'].includes(typeData.get(this.selected.type).code)"></ul> -->


            </div>

            <!-- =================================================== NRK / customer reference ====================================================================== -->
<!--            <div class="left-info">
              <ul class="flex-outer">

                <li>
                  <p>Nippon Rika reference</p>
                </li>
                <li>
                  <label>Issue date</label>
                  <ngx-doc-form-date class="fullwidth" [(value)]="$any(selected).issueDate" [disabled]="locked"></ngx-doc-form-date>
                </li>
                <li>
                  <label>Doc no</label>
                  <ngx-doc-form-texfield class="fullwidth" [value]="selected | documentNumber : null : false" [disabled]="true">
                  </ngx-doc-form-texfield>
                </li>
                <li *ngIf="!['IN', 'PFIN'].includes(typeData.get(selected.type).code)">
                  <label>Edit</label>
                  <ngx-doc-form-texfield class="fullwidth" [value]="(selected.editCount < 10 ? '0' : '') + selected.editCount" [disabled]="true">
                  </ngx-doc-form-texfield>
                </li>
                <li>
                  <label>Name override</label>
                  <div><div *ngIf="selected.nameOverride?.length" style="color:gray">{{ selected.code }}↴</div>
                  <ngx-doc-form-texfield class="fullwidth" [(value)]="selected.nameOverride" [disabled]="locked">
                  </ngx-doc-form-texfield></div>
                </li>
                <!~~ <li>
                  <label>Internal</label>
                  <ngx-doc-form-texfield class="fullwidth" [value]="selected.internal || tree?.linkedFC?.code || tree?.linkedOR?.code" (valueChange)="selected.internal = $event" [disabled]="locked"></ngx-doc-form-texfield>
                </li> ~~>
                <li>
                  <label>Quotation ref.</label>
                  <ngx-doc-form-texfield class="fullwidth"
                    [(value)]="selected.supplierReference" [disabled]="locked"></ngx-doc-form-texfield>
                </li>


                <li>
                  <p>Customer reference</p>
                </li>
                <li>
                  <label>Name</label>
                  <ngx-doc-form-filter-select class="fullwidth" [options]="customerReferenceOptions" [(value)]="$any(selected).customerReference" (valueChange)="customerNameChange($event)" [disabled]="locked" placeholder="Select customer"></ngx-doc-form-filter-select>
                </li>
                <li *ngIf="!selected.customerReference && selected.customerName">
                  <label>&nbsp;</label>
                  <ngx-doc-form-texfield class="fullwidth" [(value)]="selected.customerName" [disabled]="true"></ngx-doc-form-texfield>
                </li>
                <li>
                  <label>PO #</label>
                  <ngx-doc-form-texfield class="fullwidth" [(value)]="selected.customerDocumentNumber" [disabled]="locked">
                  </ngx-doc-form-texfield>
                </li>
                <li>
                  <label>PO Date</label>
                  <ngx-doc-form-date class="fullwidth" [(value)]="$any(selected).customerDocumentDate" [disabled]="locked"></ngx-doc-form-date>
                </li>
                <li *ngIf="selected?.customerPoPosition !== null && selected.customerPoPosition !== undefined">
                  <label>PO Position</label>
                  <ngx-doc-form-texfield class="fullwidth" [(value)]="selected.customerPoPosition" [disabled]="locked"></ngx-doc-form-texfield>
                </li>
                <li *ngIf="selected?.partialDelivery?.el > 0 && selected?.partialDelivery?.of > 0">
                  <label>Partial Delivery</label>
                  <div class="fullwidth" *ngIf="selected.partialDelivery">
                    <ngx-doc-form-texfield [(value)]="$any(selected).partialDelivery.el"
                      [styles]="{width:'4em'}" mode="integer" [disabled]="locked"></ngx-doc-form-texfield>&nbsp;&nbsp;/&nbsp;&nbsp; 
                    <ngx-doc-form-texfield [(value)]="$any(selected).partialDelivery.of"
                      [styles]="{width:'4em'}" mode="integer" [disabled]="locked"></ngx-doc-form-texfield>
                  </div>
                </li>
                <li>
                  <label>FC Doc #</label>
                  <ngx-doc-form-texfield class="fullwidth" [value]="tree?.linkedFC?.customerDocumentNumber" [disabled]="true">
                  </ngx-doc-form-texfield>                  
                </li>
                <li>
                  <label>FC Date</label>
                  <ngx-doc-form-date class="fullwidth" [value]="tree?.linkedFC?.customerDocumentDate" [disabled]="true"></ngx-doc-form-date>                  
                </li>


                <li *ngIf="tree.linkedCS">
                  <p>Shipment reference</p>
                </li>
                <li *ngIf="tree.linkedCS">
                  <label>Related CS</label>
                  <ngx-doc-form-texfield class="fullwidth" [(value)]="this.selected.transportRun.relatedCS" [disabled]="true"></ngx-doc-form-texfield>
                </li>
                
                <li>
                  <p>Manufacturer reference</p>
                </li>
                <li>
                  <label>Project #</label>
                  <ngx-doc-form-texfield class="fullwidth" [value]="selected.internal || tree?.linkedFC?.code || tree?.linkedOR?.code" (valueChange)="selected.internal = $event" [disabled]="locked"></ngx-doc-form-texfield>
                </li>
                <li>
                  <label>Machine S/N</label>
                  <ngx-doc-form-texfield class="fullwidth" [(value)]="selected.machineSN" [disabled]="locked"></ngx-doc-form-texfield>
                </li>

              </ul>
            </div>
-->
            <!-- ===================================== delivery address, place of loading, service provided ... ================================================================= -->
<!--            <div class="mid-info">
              <ul class="flex-outer">
                <li *ngIf="!locked">
                  <div class="delivery-service-radio">
                    <ul>
                      <li>Type:</li>
                      <li><input [attr.disabled]="readOnly ? true : null" type="radio" value="delivery" name="invoiceType" [(ngModel)]="selected.invoiceType" (click)="onInvoiceType('delivery', false)" /><span (click)="onInvoiceType('delivery')">Delivery</span></li>
                      <!~~ <li><input [attr.disabled]="readOnly ? true : null" type="radio" value="pickup" name="invoiceType" [(ngModel)]="selected.invoiceType" (click)="onInvoiceType('pickup', false)"/><span (click)="onInvoiceType('pickup')">Pickup</span></li> ~~>
                      <li><input [attr.disabled]="readOnly ? true : null" type="radio" value="service" name="invoiceType" [(ngModel)]="selected.invoiceType" (click)="onInvoiceType('service', false)"/><span (click)="onInvoiceType('service')">Service</span></li>
                    </ul>
                  </div>
                </li> 

                <ngx-doc-form-address-selector *ngIf="this.selected.invoiceType ==='delivery' && !['DN'].includes(typeData.get(this.selected.type).code)" label="Delivery address" [businesses]="deliveryBusinesses"
                  [compilation]="selected" [contacts]="contacts" [contactField]="'deliveryContact'" 
                  [(address)]="selected.deliveryAddress" [(business)]="selected.deliveryRecipient" [contactType]="contactTypes.Delivery" (contactChange)="onDeliveryChange($event)"
                  (businessChange)="data.setCSIdentifier(selected)" [disabled]="locked">
                </ngx-doc-form-address-selector>
                <!~~ <ngx-doc-form-address-selector *ngIf="this.selected.invoiceType ==='pickup'" label="Pick up address" [businesses]="deliveryBusinesses" 
                  [compilation]="selected" [contacts]="contacts" [contactField]="'pickUpContact'" 
                  [(address)]="selected.pickUpAddress" [(business)]="selected.pickUpRecipient"
                  [contactType]="contactTypes.Delivery" (contactChange)="onDeliveryChange($event)" [disabled]="locked">
                </ngx-doc-form-address-selector> ~~>
                <ngx-doc-form-address-selector *ngIf="this.selected.invoiceType ==='service'" label="Service address" [businesses]="deliveryBusinesses" 
                  [(address)]="selected.serviceProvided" [(business)]="selected.serviceRecipient"
                  [contactType]="contactTypes.Delivery" [disabled]="locked">
                </ngx-doc-form-address-selector>

                <!~~ <ngx-doc-form-address-selector  *ngIf="data.visibleMap.placeOfLoading" [label]="['SPO', 'SPC', 'PFSPO', 'OC', 'DN','PL'].includes(typeData.get(selected.type).code) && selected.invoiceType === 'pickup' ? 'Place of delivery' : 'Place of loading'" [businesses]="placeOfLoadingBusinesses" 
                  [compilation]="selected" [contacts]="contacts" [contactField]="'placeOfLoadingContact'" 
                  [(address)]="selected.placeOfLoading"  [(business)]="selected.placeOfLoadingRecipient"
                  (businessChange)="!selected.placeOfLoadingRecipient && selected.placeOfLoading = null" [disabled]="locked">
                </ngx-doc-form-address-selector> ~~>
                <ngx-doc-form-address-selector  *ngIf="data.visibleMap.placeOfLoading" [label]="selected.invoiceType === 'pickup' ? 'Place of delivery' : 'Place of loading'" [businesses]="placeOfLoadingBusinesses" 
                  [compilation]="selected" [contacts]="contacts" [contactField]="'placeOfLoadingContact'" 
                  [(address)]="selected.placeOfLoading"  [(business)]="selected.placeOfLoadingRecipient"
                  (businessChange)="!selected.placeOfLoadingRecipient && selected.placeOfLoading = null" [disabled]="locked">
                </ngx-doc-form-address-selector>

              </ul>
            </div>
-->
            <!-- =================================================== manufacturer, importer ====================================================================== -->
<!--            <div class="right-info">
              <ul class="flex-outer">
                <ngx-doc-form-address-selector [label]="selected.invoiceType === 'service' ? 'Serviceprovider address' : 'Manufacturer address'" [businesses]="manufacturerBusinesses" 
                  [compilation]="selected" [contacts]="contacts" [contactField]="'manufacturerContact'"
                  [(address)]="selected.manufacturerServiceproviderAddress" [(business)]="selected.manufacturerRecipient"
                  (businessChange)="data.setCSIdentifier(selected)" [disabled]="locked">
                </ngx-doc-form-address-selector>

                <ngx-doc-form-address-selector *ngIf="data.visibleMap.importerInfo && (!selected.invoiceType || selected.invoiceType != 'service')"
                  label="Importer address" [businesses]="importerBusinesses" [(address)]="selected.importerAddress" [(business)]="selected.importerRecipient" [disabled]="locked"
                  (businessChange)="!selected.importerRecipient && selected.importerAddress = null">
                </ngx-doc-form-address-selector>

                <li *ngIf="!selected.invoiceType || selected.invoiceType != 'service'">
                  <label>Transportation</label>
                  <div>Carrier / Method</div>
                  <ngx-doc-form-filter-select class="fullwidth" [value]="tree?.linkedCS?.meansOfTransport || selected.meansOfTransport" placeholder="Select transportation"
                    [options]="meansOfTransportOptions" (valueChange)="onMeansOfTransportChanged($event)" [disabled]="locked || selected.tmp?.relatedCombinedShipment">
                  </ngx-doc-form-filter-select>
                  <div *ngIf="!(locked || tree.linkedCS)" style="display:flex;flex-direction:row;margin-top:3px;width:100%;">
                    <ngx-doc-form-texfield style="width:100%;" class="fullwidth" [(value)]="selected.meansOfTransport"></ngx-doc-form-texfield>
                    &nbsp;<button class="nrk-doc-button" (click)="addMeansOfTransport()" title="Add transportation to list">+</button>
                    &nbsp;<button class="nrk-doc-button" (click)="removeMeansOfTransport()" title="Remove transportation from list">-</button>
                  </div>
                </li>
                <li *ngIf="['DN'].includes(typeData.get(selected.type).code)">
                  <label>Tracking Code</label>
                  <ngx-doc-form-texfield class="fullwidth" [(value)]="selected.trackingCode" [disabled]="locked"></ngx-doc-form-texfield>
                </li>
              </ul>
            </div>
-->          
          
          </div>

          <div *ngIf="this.data.visibleMap.invoiceAddress" class="mb-3 p-1" style="background-color: rgba(92,92,92,0.05);">
            <i>Invoice address</i>
            <div>
              <input type="checkbox" [ngModel]="docSubComponents.getSection('invoiceAddress')?.checked"
                (change)="docSubComponents.toggleItem(docSubComponents.getSection('invoiceAddress'))" title="show in PDF"/>
              {{docSubComponents.invoiceAddress}}
            </div>
          </div>


          <div *ngIf="this.data.visibleMap.pricingDisclaimer" class="mb-3 p-1" style="background-color: rgba(92,92,92,0.05);">
            <i>Pricing Disclaimer</i>
            <div>
              <input type="checkbox" [(ngModel)]="selected.pricingDisclaimer" title="show in PDF"/> Please note the delivery date specified in the order does not fall within the period stipulated by a quantity contract, price agreement or similar. We reserve the right to adjust the prices, quantities and lead time of the goods accordingly.
            </div>
          </div>

          <!-- ================================================= transport run && report fields ================================================================== -->

          <ngx-report-dates #reportDates [compilation]="selected" [disabled]="locked" (dateChange)="reportDatesChanged()"></ngx-report-dates>

          <!-- -->

          <div *ngIf="['OF'].includes(typeData.get(selected.type)?.code)" style="margin-top:1rem">
            <p>
              <input type="checkbox" [(ngModel)]="selected.offerDisclaimer" title="show in PDF"/>
              Please note that the quoted quantity may deviate from confirmed delivery quantity, depending on our MOQ, which will be determined upon dispatch from our factory.
            </p>
            <p>Thank you for your understanding.</p>
            <p>Bitte beachten Sie, dass die angegebene Menge von der bestätigten Liefermenge abweichen kann, je nach unserer Mindestbestellmenge, die beim Versand aus unserem Werk festgelegt wird. </p>
            <p>Vielen Dank für Ihr Verständnis.</p>
          </div>
          <!-- =============================================== line items / combined shipment items ======================================================= -->

          <ngx-line-item-container *ngIf="!data.visibleMap.combinedShipment" #lineItems [priceDate]="priceDate"
            [documentComponent]="this"
            [compilation]="selected" [disabled]="locked || readOnly" (lineItemsChanged)="onLineItemsChanged($event)"
            [baseProducts]="baseProducts" (copyToClipboard)="copyToClipboard($event)"></ngx-line-item-container>
          <br>
          <ngx-line-item-container *ngIf="data.visibleMap.optionalLineItems" #optionalLineItems [optional]="true"
            [documentComponent]="this"
            [compilation]="selected" [disabled]="locked || readOnly" (lineItemsChanged)="onOptionalLineItemsChanged()"
            [baseProducts]="baseProducts" (copyToClipboard)="copyToClipboard($event)"></ngx-line-item-container>
          <br>

          <ngx-combined-shipment *ngIf="data.visibleMap.combinedShipment"
            [compilation]="selected"
            [latestVersionItems]="data.latestVersionItems"
            [items]="items"
            [disabled]="locked"
            [parent]="this"
            (reloadItems)="reloadItems()"
            (setCurrentDocument)="scrollTop();setCurrentDocumentByCode($event)"
            (evalDateFields)="reportDates.evalFields(); reportDates.syncDisplayDates()"
          ></ngx-combined-shipment>
          <br>

            <!-- <span class="row">
              <label>Inv due date</label>&nbsp;&nbsp;&nbsp;
              <ngx-doc-form-date [(value)]="$any(selected).dueDate" class="fullwidth" [disabled]="locked || readOnly"></ngx-doc-form-date>
              &nbsp;&nbsp;&nbsp;
              <ngx-doc-form-date [(value)]="$any(selected).nextPaymentDate" class="fullwidth" (valueChange)="setField('nextPaymentDate', $event)" [disabled]="readOnly"></ngx-doc-form-date>
              &nbsp;&nbsp;&nbsp;
              <ngx-doc-form-texfield [(value)]="selected.dueText" 
                placeholder="Due text" [disabled]="readOnly" (valueChange)="setField('dueText', $event)"
                [styles]="{width: '49em'}">
              </ngx-doc-form-texfield>
            </span> -->
          <div *ngIf="data.visibleMap.dueDate && selected.paymentPlan.termsOfPayment !== 'NO COMMERCIAL VALUE - CUSTOMS PURPOSE ONLY'" class="row due-date">
            <div>
              <label>Inv Due Date</label>&nbsp;&nbsp;&nbsp;
              <ngx-doc-form-date [(value)]="$any(selected).dueDate" class="fullwidth" [disabled]="locked || readOnly"></ngx-doc-form-date>
            </div>
            <div>
              <button class="nrk-button" title="update due date" (click)="updateDueDate()" [disabled]="locked || readOnly">update</button>
            </div>
            <div>
              <label>Next IN Due Date</label>&nbsp;&nbsp;&nbsp;
              <ngx-doc-form-date [(value)]="$any(selected).nextPaymentDate" class="fullwidth" (valueChange)="setField('nextPaymentDate', $event)" [disabled]="readOnly"></ngx-doc-form-date>
            </div>
            <div>
              <label>Due text</label>&nbsp;&nbsp;&nbsp;
              <!-- <ngx-doc-form-texfield [(value)]="selected.dueText" class="fullwidth"
                placeholder="Due text" [disabled]="readOnly" (valueChange)="setField('dueText', $event)">
              </ngx-doc-form-texfield> -->
              <ngx-form-text [multiline]="1" [(value)]="selected.dueText" class="fullwidth"
                placeholder="Due text" [disabled]="readOnly" (focusout)="setField('dueText', selected.dueText)"></ngx-form-text>
            </div>
            <div><button class="nrk-button" (click)="copyToClipboard(getAtDueText())">&commat;</button></div>
          </div>

          <!-- ======================================================= additional fields ... ================================================================== -->

          <div class="bottom-section">
            <ngx-document-sub-components #docSubComponents [compilation]="this.selected" [locked]="locked" [documentComponent]="this"
              [relatedDocuments]="relatedDocuments" (documentChange)="setCurrentDocumentByCode($event)">
            </ngx-document-sub-components>
          </div>


          <!-- <div class="doc-footer"> -->
          <div class="sidebar footer" style="text-align:center">
            <div>
              <button class="btn btn-default btn-md" (click)="cancel(selected)">Close</button>
              <button *ngIf="sideBarShow && !this.readOnly && !locked" class="btn btn-default btn-md" (click)="undoEdit(selected)">Cancel Edit</button>
              <button *ngIf="!this.readOnly && (locked && canModify(true)) && canEdit()" class="btn btn-primary btn-md" (click)="edit()" [attr.disabled]="tree.isLoading || null">Edit</button>
              <button *ngIf="!this.readOnly && locked && selected.type != 16 && canModify(false) && getDocumentStatus() != 'cancelled'" class="btn btn-primary btn-md" (click)="lock(false)">{{isFirstVersion ? 'New version' : 'Unlock'}}</button>
              <button *ngIf="!this.readOnly && !locked" class="btn btn-primary btn-md" (click)="save(selected)" [attr.disabled]="tree.isLoading || null">Save</button>
              <button *ngIf="!this.readOnly && canModify(true, true) && canEdit() && getDocumentStatus() != 'cancelled'" class="btn btn-primary btn-md" (click)="cancelDocument(selected)">Cancel document</button>
              <button *ngIf="!this.readOnly && !locked && selected._id && selected.draft" class="btn btn-default btn-md" (click)="cancelDraft(selected)">Cancel draft</button>
              <button *ngIf="!this.readOnly && !locked && selected.draft" class="btn btn-info btn-md" (click)="save(selected, true)">Save draft</button>
              <button *ngIf="!this.readOnly && selected._id && typeData.get(selected.type).code !== 'TOF'" class="btn btn-info btn-md"  (click)="onCloneDocument(true)">Clone attached</button>
              <button *ngIf="!this.readOnly && 
                  selected._id 
                  && typeData.get(selected.type).code !== 'OC'
                  && (!tree.linkedObic || !['PFSPO', 'SPO'].includes(typeData.get(selected.type).code))
                " class="btn btn-info btn-md" (click)="onCloneDocument(false)"
                >
                  Clone {{ typeData.get(selected.type).code === 'TOF' ? 'template' : 'detached' }}
              </button>
              <button class="btn btn-info btn-md"  (click)="onShowDocumentPreview()" [attr.disabled]="previewDisabled">Preview</button>
              <button class="btn btn-default btn-md" (click)="loadData(true, true)" title="refresh data"><i class="ion-refresh"></i></button>
              <!-- <button class="btn btn-danger btn-md" (click)="api.fixErrors(false)">Fix store</button>
              <button class="btn btn-danger btn-md" (click)="api.fixErrors(true)">Fix restore</button> -->
            </div>
          </div>

        <!-- </form> -->
      </div>

      <!-- *********************************************************** document PDF preview ***************************************************************************  -->

      <div *ngIf="showDocumentPreview || showDocumentPreviewHidden" class="preview" [ngStyle]="showDocumentPreviewHidden ? { 'position': 'absolute', 'top': 0, 'left': 0, 'display': 'none' } : {}">
        <ngx-document-printer
          #documentPrinter 
          [compilation]="selected"
          [documentComponent]="this"
          [userOptions]="$any(data.userOptions)"
          [lineItemsComponent] = "lineItems"
          [deliveryConditions]="getSelected($any(selected).deliveryConditions, $any(deliveryConditionOptions))"
          [taxHint]="getSelected(selected.taxHint, $any(taxHintOptions))"
          [visibleSections]="visibleSections"
          [relatedDocuments]="$any(relatedDocuments)"
          [latestVersionItems]="data.latestVersionItems"
          (done)="onShowDocumentPreview(false)">
        </ngx-document-printer>
        <!-- [issuedBy]="getSelected($any(selected).issuedBy, data.userOptions)" -->
      </div>

      <ngx-product-wizard
        #offerWizard
        [offerWizard]="true"
        [(show)]="showWizard" 
        [compilation]="selected"
      ></ngx-product-wizard>
    
    </div>
  </ng-sidebar>


  <!-- *********************************************************** document overview ***************************************************************************  -->

  <div ng-sidebar-content>
    <ngx-page-container>

      <div style="width:100vw;height:100vh;position:absolute;top:0;left:0;background-color:#0002" *ngIf="loading">
        <ngx-loading-spinner [loading]="loading" [style]="{position:'relative',top:'1.3em',width:'10em',left:'calc(50% - 11em)'}"></ngx-loading-spinner>
      </div>

      <h1>Document</h1>
      <hr>

      <!-- ================================================================= gray filter box =================================================================== -->
      <div class="filter" *ngIf="auth.user && !isOffersPage()">
        <div style="display:flex; align-items: center;">
          <div>
            <h3>Filter</h3>
          </div>
          <div>
            <ul>
              <li>
              </li>
              <li>
                <label>Document type</label>
                <ngx-doc-form-filter-select class="test3" [options]="$any(compilationTypeOptions)" [(value)]="$any(filter).doctype" (valueChange)="setDisplayedItems()"></ngx-doc-form-filter-select>            
              </li>
              <li>
                <label>Recipient</label>
                <ngx-doc-form-filter-select [options]="data.businessOptions" [(value)]="$any(filter).recipient" (valueChange)="setDisplayedItems()"></ngx-doc-form-filter-select>           
              </li>
              <li style="width:12.5em">
                <label>OBIC</label>
                <ngx-doc-form-texfield [value]="filter.obic" (keyupChange)="filter.obic=$event; setDisplayedItems()"></ngx-doc-form-texfield>           
              </li>
              <!-- <li class="ml-3">
                <label>Account manager</label>
                <ngx-doc-form-filter-select [options]="employeeOptions" [(value)]="$any(filter).accountManager" (valueChange)="setDisplayedItems()"></ngx-doc-form-filter-select>           
              </li> -->
              <li>
                <label>Drafts only&nbsp;&nbsp;</label>
                <input type="checkbox" [(ngModel)]="filter.draftsOnly" (ngModelChange)="setDisplayedItems()"/>
              </li>
              <li *ngIf="filter.doctype == 1">
                <label style="display:block;margin:-1px;padding-left:9px;">Offer status</label>
                <ss-multiselect-dropdown
                  [options]="offerStatusOptions"
                  [(ngModel)]="filter.offerStatus"
                  (ngModelChange)="setDisplayedItems()">
                </ss-multiselect-dropdown>
              </li>
              <!-- <li>
                <div class="row">
                  <div class="inline-block" style="padding:0.2rem;width:2rem;margin-left:1rem"><label>Lot</label></div>
                  <div class="inline-block" style="padding:0.2rem"><ngx-doc-form-texfield [(value)]="filter.lot"></ngx-doc-form-texfield></div>
                  <div class="inline-block" style="padding:0.2rem;width:5rem"><button class="nrk-button" (click)="getDocCodesByLot(filter.lot)">Apply</button></div>
                </div>
              </li> -->
              <li>
                <button class="button" (click)="onClearFilter(); setDisplayedItems()">clear</button>            
              </li>
              <!-- <li style="padding-left:8em">
                <div>CPos = Customer Purchase Order Position</div>
                <div>CPD = Customer Partial Delivery (item / total)</div>
              </li> -->
            </ul>

            <ul style="padding-top: 0">
              <li>
                <div style="display: flex">
                  <div>PO date from:</div><div><ngx-doc-form-date [(value)]="$any(filter).poDateFrom" (valueChange)="setDisplayedItems()"></ngx-doc-form-date></div>
                </div>
                <div style="display: flex">
                  <div>PO date to:</div><div><ngx-doc-form-date [(value)]="$any(filter).poDateTo" (valueChange)="setDisplayedItems()"></ngx-doc-form-date></div>
                </div>
              </li>
              <li>
                <div style="display: flex">
                  <div>EXW date from:</div><div><ngx-doc-form-date [(value)]="$any(filter).exwDateFrom" (valueChange)="setDisplayedItems()"></ngx-doc-form-date></div>
                </div>
                <div style="display: flex">
                  <div>EXW date to:</div><div><ngx-doc-form-date [(value)]="$any(filter).exwDateTo" (valueChange)="setDisplayedItems()"></ngx-doc-form-date></div>
                </div>
              </li>
              <li>
                <div style="display: flex">
                  <div>ETA date from:</div><div><ngx-doc-form-date [(value)]="$any(filter).etaDateFrom" (valueChange)="setDisplayedItems()"></ngx-doc-form-date></div>
                </div>
                <div style="display: flex">
                  <div>ETA date to:</div><div><ngx-doc-form-date [(value)]="$any(filter).etaDateTo" (valueChange)="setDisplayedItems()"></ngx-doc-form-date></div>
                </div>
              </li>
              <li>
                <div style="display: flex">
                  <div>Due date from:</div><div><ngx-doc-form-date [(value)]="$any(filter).dueDateFrom" (valueChange)="setDisplayedItems()"></ngx-doc-form-date></div>
                </div>
                <div style="display: flex">
                  <div>Due date to:</div><div><ngx-doc-form-date [(value)]="$any(filter).dueDateTo" (valueChange)="setDisplayedItems()"></ngx-doc-form-date></div>
                </div>
              </li>
              <li>
                <div style="display: flex">
                  <div style="width:auto"><ngx-doc-form-texfield [value]="filter.lot" (keyupChange)="filter.lot=$event" placeholder="Lot Number"></ngx-doc-form-texfield></div>
                  <div><button class="nrk-button" (click)="getDocCodesByLot(filter.lot)" [disabled]="!filter.lot">Apply</button></div>
                </div>
                <div style="display: flex">
                  <div style="width:auto"><ngx-doc-form-texfield [value]="filter.tcNumber" (keyupChange)="filter.tcNumber=$event" placeholder="TC Number"></ngx-doc-form-texfield></div>
                  <div><button class="nrk-button" (click)="getDocCodesByTc(filter.tcNumber)" [disabled]="!filter.tcNumber">Apply</button></div>
                </div>
                <!-- <div><ngx-doc-form-texfield [(value)]="$any(filter).tcNumber" placeholder="TC Number"></ngx-doc-form-texfield></div>
                <div><button class="nrk-button" (click)="getDocCodesByTc()">Apply</button></div> -->
              </li>
            </ul>

          </div>
        </div>
      </div> 


      <!-- ============================================== create new documnents / documents table =================================================================== -->

      <ng-container *ngIf="data.latestVersionItems">
        <div *ngIf="!this.readOnly && !isOffersPage()" class="new-document">
          <table>
            <tr><td>Create new:</td>
              <!-- <td style="padding-left:2em">
                Issuer: 
                <nb-radio-group name="issuer-selector" [(ngModel)]="issuer">
                  <nb-radio [value]="2">NRKA</nb-radio>
                  <nb-radio [value]="4">NRKJ</nb-radio>
                </nb-radio-group>
              </td> -->
              <td><ul>
                <li *ngFor="let doc of compilationTypeOptions" class="pseudo-link" (click)="onNewDocument(doc.id)">{{doc.name}}</li>
              </ul></td>
            </tr>
          </table>
        </div>
        <div *ngIf="isOffersPage()">
          <!-- <button class="nrk-button ml-3" (click)="issuer = 2; onNewDocument(1)">create new NRKA Offer</button>
          <button class="nrk-button ml-3" (click)="issuer = 3; onNewDocument(1)">create new NRKG Offer</button> -->
          <div class="row">
            <div><button class="nrk-button ml-3" (click)="createNewOffer(typeData.get('OF').id)">create new Offer</button></div>
            <div><button class="nrk-button ml-4" (click)="createNewOffer(typeData.get('TOF').id)">create new Offer template</button></div>
            <div><div class="ml-3"><ngx-doc-form-checkbox label="Templates only" [(value)]="templatesOnly" (valueChange)="setDisplayedItems()"></ngx-doc-form-checkbox></div></div>
            <div><button class="nrk-button ml-4" (click)="manageTemplates()">manage templates</button></div>
          </div>
          <br>
        </div>
        <pagination-controls (pageChange)="docPage = $event"></pagination-controls>

        <table class="table main-table table-hover">
          <thead>
          <tr>
            <th></th>
            <th *ngFor="let col of columns; let idx = index;" class="pseudo-link" scope="col" (click)="onSort(col.id)" [ngStyle]="col.style">
              {{col.name}}<span *ngIf="filter.sort.column === col.id">&nbsp;{{filter.sort.dir > 0 ? '▲' : '▼'}}</span></th>
          </tr>
          <tr>
            <th style="text-align: center"><button class="nrk-button" (click)="clearFilter(); setDisplayedItems()">clear</button></th>
            <th *ngFor="let col of columns; index as idx" scope="col" [ngStyle]="col.style" >
              <ngx-doc-form-texfield class="fullwidth noborder" [value]="col.search" (keyupChange)="col.search=$event; setDisplayedItems()"></ngx-doc-form-texfield>
            </th>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of displayedItems | paginate: { itemsPerPage: 10, currentPage: docPage }"
                [ngClass]="{ 'table-warning': item.documentStatus === 3, 'table-info': item.draft, 'table-success': !item.draft, 'offer-template': item.type === 17 }"
                (click)="select(item)" [ngStyle]="item.type == 3 && item.completelyInvoiced !== true ? { color: '#bd0221' } : null">
              <td><ngx-document-tree [compilation]="item" [loadFromItems]="true" (show)="(!sideBarOpen && toggleSidebar($event)) || setCurrentDocumentByCode($event.code)"></ngx-document-tree></td>
              <ng-container *ngFor="let col of columns">
                <td *ngIf="col.id !== 'documentStatus' || item.type !== typeData.get('CS').id" (click)="toggleSidebar(item)" [ngStyle]="col.style">{{getItemString(item, col.id)}}</td>
                <td *ngIf="col.id === 'documentStatus' && item.type === typeData.get('CS').id" [nbPopover]="statusSelect" style="cursor:context-menu" [ngStyle]="col.style">{{getItemString(item, col.id)}}</td>
                <ng-template #statusSelect>
                  <div class="m-3">
                    <h6>Change Transport Status to:</h6>
                    <div class="text-center mb-2"><button class="nrk-button" (click)="setTransportStatus(item, 1)">Planned</button></div>
                    <div class="text-center mb-2"><button class="nrk-button" (click)="setTransportStatus(item, 2)">En route</button></div>
                    <div class="text-center mb-2"><button class="nrk-button" (click)="setTransportStatus(item, 3)">Completed</button></div>
                  </div>
                </ng-template>
              </ng-container>
              <!-- <td><button class="btn btn-default btn-sm" (click)="toggleSidebar(item)"><i class="ion-edit"></i></button></td> -->
            </tr>
          </tbody>
        </table>
        
      </ng-container>
      <div *ngIf="!data.latestVersionItems" class="loading">
        <ngx-loading-spinner [loading]="true"></ngx-loading-spinner>
      </div>
    </ngx-page-container>
  </div>
</ng-sidebar-container>

<ngx-reports-printer #reportsPrinter *ngIf="this.reportsSearch" style="display:none" [search]="reportsSearch" [pdfSidebar]="true"></ngx-reports-printer>

<!-- modify internal updates -->
<ngx-internal-updates #internalUpdates [linked]="false"></ngx-internal-updates>


<ngx-profit-margin #profitCalc [compilation]="this.selected" [type]="profitMarginType.cs" [disabled]="locked"></ngx-profit-margin>
<ngx-profit-margin #profitCalcOCSPO [compilation]="this.selected" [type]="profitMarginType.ocSpo" [disabled]="locked"></ngx-profit-margin>    


